module.exports = __webpack_public_path__ + "static/Artboard_5-0eb8572adf2d16ebd54231f6eddc68f7.svg";